module.exports = __webpack_public_path__ + "img/tb-01@2x.35991ec7.png";